import {Injectable} from '@angular/core';

import {AppSettingsService, BaseService, ServiceManager} from 'iui-iconectiv-lib';
import {Observable} from "rxjs";
import { map, flatMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from "@angular/common/http";


const GET_ATTACHMENT_URL = '/api/account/attachment/';

@Injectable()
export class RegionalUserAgreementService extends BaseService {

  constructor(serviceManager: ServiceManager,
              private http: HttpClient,
              private appSettings: AppSettingsService) {
    super(serviceManager);
  }

  getAttachmentDownloadUrl(): Observable<string> {
    return this.emitObservable(
      this.appSettings.getSettings().pipe(map(settings => {
        return this.getServer(settings) + GET_ATTACHMENT_URL;
      }))
    );
  }

  saveAccountRua(rualistJson: string): Observable<any> {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + '/api/account/attachment';
      return this.http.post(url, rualistJson, {headers: new HttpHeaders().append('Content-Type', 'application/json')});
    })));
  }

}
